import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { BrandProvider } from "./helper/BrandContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <BrandProvider>
      <App />
      <Toaster />
    </BrandProvider>
  </BrowserRouter>
);
